module.exports = __webpack_public_path__ + "static/HalconMilenario-9796401aff3c6e2d7298c48b1d2ff79e.jpg";